// generated by srcset-codegen
import src from "./pencil-icon.svg";

const width = 12;
const height = 12;
export default { src, width, height };
